const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Resolve a question image reference to a displayable URL.
// - Full http(s) links and data URLs are used as-is (pasted image links).
// - Otherwise it's an object-storage path served by the backend.
export function quizImageUrl(image) {
  if (!image) return null;
  if (/^https?:\/\//i.test(image) || image.startsWith("data:")) return image;
  return `${BACKEND}/api/quizzes/image/${image}`;
}
